
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import Cocktails from './cocktails';
import EventsScreen from './events';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);

    const specials = [
        {
            image: require('./assets/specials1.png'),
            title: 'Fajita Wednesday',
            description: "Every Wednesday, get 25% off all fajitas — served hot, loud, and loaded with flavor. Whether you go classic, spicy, or veggie, it's the midweek pick-me-up you didn't know you needed."
        },
        {
            image: require('./assets/specials2.png'),
            title: 'Taco Tuesday',
            description: "Build your own taco flight with any 4 tacos for just $10 — all day, every Tuesday. Mix, match, repeat. It's the perfect excuse to try something new (or stick with your faves). 🌮"
        },
        {
            image: require('./assets/specials3.png'),
            title: 'Monday Munchies',
            description: "Mondays just got a whole lot tastier. All day long, enjoy 25% off all appetizers — no catch, just cravings."
        },
        {
            image: require('./assets/specials4.png'),
            title: 'Karaoke Night',
            description: "Every Thursday night after 8PM, the stage is yours. Whether you're singing your heart out 🎤 or cheering from the sidelines 🙌, it's all about good vibes, big energy, and zero judgment."
        }
    ];

    const SpecialCard = ({ item }) => (
        <div style={{
            width: '48%',
            backgroundColor: 'white',
            borderRadius: 20,
            padding: 15,
            marginBottom: 15,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
        }}>
            <img
                src={item.image}
                onContextMenu={(e) => e.preventDefault()}
                style={{
                    width: '100%',
                    height: 140,
                    objectFit: 'cover',
                    borderRadius: 15,
                    pointerEvents: 'none',
                    marginBottom: 12
                }}
            />
            <h3 style={{
                color: '#333',
                fontSize: 18,
                fontWeight: '700',
                margin: '0 0 8px 0',
                fontFamily: 'Arial'
            }}>
                {item.title}
            </h3>
            <p style={{
                color: '#666',
                fontSize: 13,
                lineHeight: '1.4',
                margin: 0,
                fontFamily: 'Arial'
            }}>
                {item.description}
            </p>
        </div>
    );

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} showCocktails={ setShowCocktails} showEvents={ setShowEvents} setShowListProduct={setShowListProduct} goHome={setShowHappy} goCategories={setshowCategories}>
                <div style={{padding: '0 20px', height: 780, overflowY: 'auto'}}>
                    
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10, marginTop: 10}}>
                        <img
                            src={require('./assets/logo.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 340, height: 100, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                    </div>

                    
                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10, marginTop: 10}}>
                        <img
                            src={require('./assets/Margaritas.jpeg')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 640, height: 700, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                    </div>




                   

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
            </LayoutContent>
        </div>
    );
}
export default Index;